import { render } from "./SubAccountMI.vue?vue&type=template&id=5db738ae"
import script from "./SubAccountMI.vue?vue&type=script&lang=js"
export * from "./SubAccountMI.vue?vue&type=script&lang=js"
script.render = render

export default script